import { font, query } from '@design/templateFns';
import { FC } from 'react';
import styled from 'styled-components';

export interface ListCountProps {
  currentPage?: number;
  pageSize?: number;
  totalRecords?: number;
  type: string;
}

/*** STYLING ***/
export const Text = styled.div`
  font-weight: 700;

  @media screen and (${query.atLeast('tablet')}) {
    ${font('subhead-sm')};
  }
`;

const ListCount: FC<ListCountProps> = ({ pageSize, currentPage, totalRecords, type }) => {
  let recordStart: number | undefined;
  let recordEnd: number | undefined;

  if (
    typeof pageSize === 'number' &&
    typeof currentPage === 'number' &&
    typeof totalRecords === 'number'
  ) {
    recordStart = totalRecords > 0 ? pageSize * (currentPage - 1) + 1 : 0;
    recordEnd = Math.min(pageSize * currentPage, totalRecords);
  }

  return (
    <Text data-testid="range-msg">
      {recordStart ?? '?'}-{recordEnd ?? '?'} of {totalRecords} {type}
    </Text>
  );
};

export default ListCount;
